import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import FindStoresAction from 'yoda-site-components/lib/actions/FindStoresAction';
import SlidePanel from 'yoda-site-components/lib/components/SlidePanel/SlidePanel';
import Button from 'yoda-core-components/lib/components/Button/Button';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Close from 'yoda-core-components/lib/assets/svg/Close.svg';
import StoreIconFilled from 'yoda-site-components/lib/assets/svg/store-icon-filled.svg';
import { FIND_STORE_THEMES_VISIT_STORE_TO_PURCHASES } from 'yoda-site-components/lib/common/Constants';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';
import FindStoresTabContainerLazy from 'yoda-site-components/lib/components/FindStores/components/FindStoresTabContainer/FindStoresLazy';
import FindStoresProductCardLazy from 'yoda-site-components/lib/components/FindStores/components/FindStoresProductCard/FindStoresLazy';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { initProductOptions } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { checkAvailabilityAnalytics } from '../../actions/AnalyticsAction';
import getVisitStoreToPurchaseAction from '../../actions/VisitStoreToPurchaseAction';
import ProductConstants from '../../helpers/ProductConstants';

import * as styles from './VisitStoreToPurchase.css';

const cx = classNames.bind(styles);
const { STORE_PICKUP_LABEL } = ProductConstants;

/* istanbul ignore next */
export class VisitStoreToPurchase extends Component {
    static defaultProps = {
        actions: {},
        productDetails: {},
        productOptions: {},
        selectedProduct: {},
        findStoresDetails: {},
        deviceType: {},
        visitStoreToPurchase: {},
        bopisMessage: '',
        featureFlags: {},
        sdpuStoreDetails: {},
        pageSize: 10,
        selectedQuantity: 0,
        selectedStore: '',
        isVisitStoreWithFlag: false,
    };

    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        findStoresDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        visitStoreToPurchase: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        bopisMessage: PropTypes.string,
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        sdpuStoreDetails: PropTypes.oneOfType([PropTypes.object]),
        preferences: PropTypes.object.isRequired,
        pageSize: PropTypes.number,
        selectedQuantity: PropTypes.number,
        selectedStore: PropTypes.string,
        isNative: PropTypes.bool,
        isVisitStoreWithFlag: PropTypes.bool,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.onFindStoresClosePanel = this.onFindStoresClosePanel.bind(this);
        this.findStoresPageData = this.findStoresPageData.bind(this);
        this.findMoreStoresPage = this.findMoreStoresPage.bind(this);
        this.handleVisitStoresToPurchase = this.handleVisitStoresToPurchase.bind(this);
        this.state = {
            selectedOption: '',
            tooltipEnabled: this.props.deviceType.isDesktop,
            isSlidePanelOpen: false,
            isSlidePanelOpenOnce: false,
            isSticky: false,
        };
        this.stickyElemRef = React.createRef();
    }

    componentWillReceiveProps(nextProps) {
        const {
            visitStoreToPurchase: { zipCode },
        } = nextProps;
        const {
            visitStoreToPurchase: { zipCode: prevZipCode },
        } = this.props;
    }

    onFindStoresClosePanel() {
        this.setState({ isSlidePanelOpen: false });
    }

    processScroll = () => {
        window.requestAnimationFrame(() => {
            const currentStickyElem = this.stickyElemRef.current;
            /* istanbul ignore next */
            if (currentStickyElem) {
                const scrollPos = currentStickyElem.getBoundingClientRect();
                if (parseInt(scrollPos.top, 0) > 180) {
                    this.setState({ isSticky: false });
                }

                if (parseInt(scrollPos.top, 0) <= 100 && parseInt(scrollPos.bottom, 0) > 0) {
                    this.setState({ isSticky: true });
                }
                this.ticking = false;
            }
        });
    };

    scrollElemRef = () => {
        if (this.stickyElemRef && !this.ticking) {
            this.processScroll();
        }
        this.ticking = true;
    };

    getFindStoresPayload = (zipCode) => {
        const {
            featureFlags: { enableFindAStorePageRedesign = true },
            preferences,
            pageSize,
            productOptions: { filteredItems },
        } = this.props;
        return {
            pageSize,
            isLoading: !!zipCode,
            zipCode,
            miles: (enableFindAStorePageRedesign && preferences && preferences.defaultRadius) || 75,
            showAvailable: false,
            skuId: filteredItems[0].id,
        };
    };

    getProductInfo = () => {
        const { productDetails, productOptions } = this.props;
        const productDetailsImage =
            productDetails.images && productDetails.images.length
                ? productDetails.images[0].url
                : '';
        return productDetails.id
            ? [].concat({
                  name: productDetails.name,
                  imageURL:
                      productOptions.productImages && productOptions.productImages.length
                          ? productOptions.productImages[0].url
                          : productDetailsImage,
                  skus:
                      productOptions.filteredItems && productOptions.filteredItems.length
                          ? productOptions.filteredItems[0].id
                          : null,
              })
            : null;
    };

    handleVisitStoresToPurchase() {
        this.setState({ isSlidePanelOpen: true });
        this.setState((prevState) => ({
            isSlidePanelOpenOnce: prevState.isSlidePanelOpenOnce
                ? prevState.isSlidePanelOpenOnce
                : true,
        }));
        const {
            productOptions: { filteredItems = [], selectedProductLot = [] },
            featureFlags: { enableFindAStorePageRedesign = true },
            actions,
            selectedStore,
            preferences,
            locationServiceStoreInfo: { inputZipCode = '' } = {},
        } = this.props;
        const { zipCode = '' } = this.props.sdpuStoreDetails;
        const selectedSkuId = filteredItems.length && get(filteredItems[0], 'id', '');
        const defaultLotId = selectedProductLot.length && get(selectedProductLot[0], 'id', '');
        const findStorePageData = {
            miles: 25,
            showAvailable: false,
            skuId: selectedSkuId || defaultLotId,
        };
        const selectedStoreZip = get(selectedStore, 'storeDetails.inputZipCode');
        const userInputZip = inputZipCode || selectedStoreZip;
        if (userInputZip) {
            actions.getVisitStoreToPurchaseAction(this.getFindStoresPayload(userInputZip));
        }
        actions.checkAvailabilityAnalytics();
    }

    findStoresPageData({ zipCode, miles, showAvailable, lat, lng }) {
        const {
            productOptions,
            featureFlags: { enableFindAStorePageRedesign = true },
            preferences,
        } = this.props;
        const findStorePageData = {
            zipCode,
            lat,
            lng,
            miles,
            showAvailable,
            skuId: get(productOptions, 'filteredItems[0].id', null),
        };

        if (enableFindAStorePageRedesign) {
            findStorePageData.isLoading = true;
            findStorePageData.pageSize = this.props.pageSize;
            findStorePageData.miles = preferences.defaultRadius;
        }

        this.props.actions.getVisitStoreToPurchaseAction(findStorePageData);
    }

    findMoreStoresPage() {
        const payload = {
            nextPageLink: this.props.findStoresDetails.nextPageLink,
        };
        this.props.actions.findMoreStoresPage(payload);
    }

    renderProductCard(productDetails, bopisMessage) {
        return (
            <ErrorBoundary>
                <FindStoresProductCardLazy
                    bopisHolidayMessage={bopisMessage}
                    product={productDetails[0]}
                    shouldOrderMsgDisplay={false}
                />
            </ErrorBoundary>
        );
    }

    renderVisitStoreHeader = () => {
        return (
            <div
                className={dt([
                    'border',
                    'border-gray-15',
                    'border-solid',
                    'flex',
                    'h-12',
                    'justify-between',
                    'mb-4',
                    'px-4',
                    'py-2',
                    'shadow-elevation1',
                    'text-black',
                ])}
            >
                <Icon
                    iconType="svg"
                    pathClassName={cx('iconPath')}
                    className={cx('svg-icon')}
                    width="32"
                    height="32"
                    viewBox="0 2 48 48"
                >
                    <StoreIconFilled />
                </Icon>
                <span className={cx('visitStoreHeader')}>{STORE_PICKUP_LABEL}</span>
                <Button buttonType="Text" onClick={this.onFindStoresClosePanel}>
                    <Icon
                        automationId="at-ydt-bopis-store-icon"
                        iconType="svg"
                        width="32px"
                        height="32px"
                        viewBox="0 0 32 32"
                    >
                        <Close />
                    </Icon>
                </Button>
            </div>
        );
    };

    render() {
        const {
            productDetails,
            productOptions,
            visitStoreToPurchase,
            bopisMessage,
            deviceType,
            selectedQuantity,
            actions,
            featureFlags: { enableFindAStorePageRedesign = true },
            isNative,
        } = this.props;
        const { isSlidePanelOpen } = this.state;
        const productDetailsImage =
            productDetails.images && productDetails.images.length
                ? productDetails.images[0].url
                : '';
        const products = productDetails.id
            ? [].concat({
                  name: productDetails.name,
                  imageURL:
                      productOptions.productImages && productOptions.productImages.length
                          ? productOptions.productImages[0].url
                          : productDetailsImage,
                  skus:
                      productOptions.filteredItems && productOptions.filteredItems.length
                          ? productOptions.filteredItems[0].id
                          : null,
              })
            : null;
        const sliderProps = {
            panelHeaderRenderer: this.renderVisitStoreHeader,
            panelIcon: 'close',
            panelTitle: '',
            panelTitleAlignment: 'justified',
            deviceType,
        };
        return (
            <>
                <div className={dt(['inline-block'])} data-automation-id="visit-store-to-purchase">
                    <div className={cx('purchase')}>
                        <Icon
                            iconType="svg"
                            pathClassName={cx('iconPath')}
                            className={cx('svg-icon')}
                            width="24"
                            height="24"
                            viewBox="0 2 48 48"
                        >
                            <StoreIconFilled />
                        </Icon>
                        <span
                            className={dt([
                                'font-open-sans-bold',
                                'smMd:text-base',
                                'leading-5',
                                'text-left',
                                'text-black',
                                'pt-0',
                                'pr-0',
                                'pb-1',
                                'pl-2',
                                'align-middle',
                            ])}
                        >
                            Visit Store to Purchase
                        </span>
                        <div
                            className={`${cx('findStoreContainer', {
                                'findStoreContainer-desktop': deviceType.isDesktop,
                            })} ${dt([
                                'pl-8',
                                'block',
                                'text-black',
                                'font-normal',
                                'smMd:text-base',
                                'text-small',
                            ])}`}
                        >
                            <Button
                                buttonType="Link"
                                automationId="visit-store-check-store"
                                className={dt(['smMd:!text-base', 'lg:text-small'])}
                                onClick={this.handleVisitStoresToPurchase}
                                size="Sm"
                            >
                                {STORE_PICKUP_LABEL}
                            </Button>
                        </div>
                    </div>
                </div>
                <div
                    data-automation-id="delivery-find-store"
                    className={`${cx(
                        'deliveryOptionContainer',
                        'sm12',
                        'md12',
                        'lg6',
                        'xl6'
                    )} ${dt(['absolute'])}`}
                >
                    <ErrorBoundary>
                        {this.state.isSlidePanelOpenOnce ? (
                            <SlidePanel
                                isOpenPanel={isSlidePanelOpen}
                                onClosePanel={this.onFindStoresClosePanel}
                                hideContentScroll
                                {...sliderProps}
                            >
                                <div>
                                    {isSlidePanelOpen && (
                                        <ErrorBoundary>
                                            <FindStoresTabContainerLazy
                                                findStoresDetails={visitStoreToPurchase}
                                                theme={FIND_STORE_THEMES_VISIT_STORE_TO_PURCHASES}
                                                findStoresAction={this.findStoresPageData}
                                                bopisHolidayMessage={bopisMessage}
                                                deviceType={deviceType}
                                                hideDirections={false}
                                                restrictMiles={false}
                                                findMoreStores={this.findMoreStoresPage}
                                                productDetails={this.getProductInfo()}
                                                enableSlimFindStores
                                                selectedQuantity={selectedQuantity}
                                                productDetailsVSP={
                                                    enableFindAStorePageRedesign && products
                                                }
                                                stickyElemRef={
                                                    enableFindAStorePageRedesign &&
                                                    this.stickyElemRef
                                                }
                                                isSticky={
                                                    enableFindAStorePageRedesign &&
                                                    this.state.isSticky
                                                }
                                                isMounted={actions.openSlidePanel}
                                                hideContentScroll
                                                fromMiniPDP={false}
                                                enableFindAStorePageRedesign={
                                                    enableFindAStorePageRedesign
                                                }
                                                featureFlags={this.props.featureFlags}
                                                isNative={isNative}
                                                isVisitStoreWithFlag={
                                                    this.props.isVisitStoreWithFlag
                                                }
                                            />
                                        </ErrorBoundary>
                                    )}
                                </div>
                            </SlidePanel>
                        ) : null}
                    </ErrorBoundary>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    productDetails: state.productDetails,
    productOptions: initProductOptions(false)(state),
    visitStoreToPurchase: state.visitStoreToPurchase,
    featureFlags: selectFeatureFlags(state),
    deviceType: state.context.deviceType || {},
    sdpuStoreDetails: state.sdpuStoreInfo,
    preferences: state.context && state.context.preferences ? state.context.preferences : {},
    selectedQuantity: state.selectedQuantity,
    selectedStore: state.selectedStore,
    isNative: get(state, 'context.isNative', false),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...FindStoresAction,
            /* Analytics Actions */
            checkAvailabilityAnalytics,
            /* Visit Store To Purchase Actions */
            getVisitStoreToPurchaseAction,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(VisitStoreToPurchase);
